import { background } from 'assets/backgrounds'
import { TermsAndPoliciesCompanyDetails } from './TermsAndPoliciesCompanyDetails'
import { TermsAndPoliciesVersionDetails } from './TermsAndPoliciesVersionDetails'
import React from 'react'
import { PolicyDocument } from 'pages/terms-and-policies/models'

type TermsAndPoliciesHeaderProps = {
  item?: PolicyDocument
}

const TermsAndPoliciesHeader = ({ item }: TermsAndPoliciesHeaderProps) => (
  <section>
    <div
      className='md:flex md:justify-between md:gap-8 w-full pt-[40px] md:pt-[80px] md:px-[143px] h-[504px] px-[16px] bg-[length:100%_323px] md:bg-[length:100%_504px] bg-no-repeat'
      style={{
        backgroundImage: `url(${background.Content.TermsAndPolicies})`,
      }}
    >
      <div className='md:col-md-6'>
        <h1 className='text-[18px] md:text-[64px] font-bold text-[#001A3D]'>
          {item ? item.title : 'Terms and Policies'}
        </h1>
        <p className='text-sm md:text-[18px] mt-[20px] md:mt-[35px] font-medium md:font-bold text-[#001A3D]'>
          {item
            ? item.summary
            : 'All our formal contracting, privacy, and policy terms keeping you informed on the way we work with you and others.'}
        </p>
      </div>
      <div className='mt-[60px] md:mt-0 flex justify-center md:col-md-4'>
        {item ? (
          <TermsAndPoliciesVersionDetails item={item} />
        ) : (
          <TermsAndPoliciesCompanyDetails />
        )}
      </div>
    </div>
  </section>
)

export default TermsAndPoliciesHeader
